import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const noopFeatureFlagContextValue = {
    useFlag: ()=>false,
    useReady: ()=>true
};
const FeatureFlagContext = /*#__PURE__*/ createContext(noopFeatureFlagContextValue);
/**
 * Host-side: wraps the assembled `{ useFlag, useReady }` value (typically
 * backed by Flipt) so every consumer below reads through this context.
 */ export function FeatureFlagStateProvider({ value, children }) {
    return /*#__PURE__*/ _jsx(FeatureFlagContext.Provider, {
        value: value,
        children: children
    });
}
/**
 * Whether a boolean feature flag is enabled. Returns `false` if the flag
 * doesn't exist, the host is unavailable, or no provider is mounted at all —
 * never throws. Pass `entityId` (e.g. the tenant id) for a flag the backend
 * targets per tenant, so both sides agree.
 */ export function useFeatureFlag(flagKey, entityId) {
    const { useFlag } = useContext(FeatureFlagContext);
    return useFlag(flagKey, entityId);
}
/**
 * Whether the flag provider has loaded its initial snapshot. `true` with no
 * provider mounted, so flag-gated queries aren't blocked forever waiting on a
 * host that was never going to show up.
 */ export function useFeatureFlagsReady() {
    const { useReady } = useContext(FeatureFlagContext);
    return useReady();
}
